import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { Subscription } from 'src/features/subscriptions/utils/types';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/schedule-plan-change/';

type MutationFnType = typeof mutationFn;

interface DTO {
    subscriptionId: string;
    service_plan: string;
    /** Defaults server-side to the earliest next_billing_date across active items. */
    effective_date?: string | null;
}

/*
 * A direct PATCH of `service_plan` is rejected - this is the only path to a plan change. Verified
 * against the live API: the body is {service_plan, effective_date}, not the full Subscription
 * serializer the OpenAPI schema declares for this action.
 */
const mutationFn = ({ subscriptionId, ...data }: DTO): Promise<Subscription> => {
    return axios.post(formatResourcePath(RESOURCE, { subscriptionId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useScheduleSubscriptionPlanChange };
